import { Zone } from '@/models/zone';
import api from '..';

const getZones = async () => {
  const baseUrl = process.env.VUE_APP_API_URL;
  const response = await api.get<Zone>(`${baseUrl}/zones`);

  return response.data;
};

export default getZones;
